import React from 'react'

const signed = (n) => `${n >= 0 ? '+' : '−'}$${Math.abs(Math.round(n)).toLocaleString()}`

/**
 * One quarter profile's headline: the count that must run, the count that must
 * be offered to get there, and how the current run rate scores against it.
 */
function BreakEvenSummaryCard({ title, mix, unit, data, offerNote, actualLabel }) {
  const clearing = data.profit >= 0
  return (
    <div className={`be-card be-stripe ${clearing ? 'be-c-good' : 'be-c-short'}`}>
      <h3>{title}</h3>
      <div className="be-mix">{mix}</div>
      <div className="be-big">
        <span className="be-n">{data.breakEven === null ? '—' : data.breakEven}</span>
        <span className="be-u">{unit}</span>
      </div>
      <div className="be-offered">{offerNote}</div>
      <div className={`be-verdict ${clearing ? 'be-ok' : 'be-bad'}`}>
        <span>{actualLabel}</span>
        <span className="be-num">{signed(data.profit)}</span>
      </div>
    </div>
  )
}

export default BreakEvenSummaryCard
